import { render, staticRenderFns } from "./DoctorLayout.vue?vue&type=template&id=4163132a"
import script from "./DoctorLayout.vue?vue&type=script&lang=js"
export * from "./DoctorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports